import { combineReducers } from "@reduxjs/toolkit";

import { documentsListingReducer } from "./DocumentsListingSlice";

export const documentsReducer = combineReducers({
  documentsListing: documentsListingReducer,
});
